import React from 'react';
import styles from './SubtitlesLoadingComponent.module.scss';
import { CustomButton } from '../../../../components/Button/Button';
import { Icon } from '../../../../components/Icon';
import { useTranslation } from 'react-i18next';
import Spinner from '../../../../../common/components/Spinner';
import { secondsToString } from '../../../../utils/TimeUtil';

const SubtitlesLoadingComponent = ({
  includeCancelButton = true,
  onCancel,
  estimatedTime,
  header,
  textLines = []
}) => {
  const { t } = useTranslation();

  return (
    <div className={styles.loadingWrapper}>
      <div className={styles.loadingTextContainer}>
        <Icon src="subtitles" className={styles.loadingLogo} />
        <h2 className={styles.loadingHeader}>
          {header}
        </h2>
        <div className={styles.loadingText}>
          {textLines.map((text, index) => (
            <p key={index}>{text}</p>
          ))}
        </div>

        <Spinner width="40px" height="40px" size="4px" className={styles.spinner} />
        <p className={styles.aproxTime}>
          {' '}
          {estimatedTime > 0
            ? t('general.editor.aprox_time', { time: secondsToString(estimatedTime) })
            : t('subtitles.editor.wait_loading')}
        </p>
      </div>
      {includeCancelButton && <CustomButton label={t('general.cancel')} variant="secondary" onClick={onCancel} />}
    </div>
  );
};

export default SubtitlesLoadingComponent;
